module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/size-febbd18f3e61681496e7bef10ba67a7d.svg";